import React from 'react'
import { storiesOf } from '@storybook/react'

import Grid from '@material-ui/core/Grid'
import Typography from '@material-ui/core/Typography'
import Paper from 'components/Paper'
import firewatchBg from './assets/firewatch_bg.jpg'

const styles = {
  padding: 16
}

storiesOf('Essentials/Paper', module)
  .add('color variants', () => (
    <Grid container direction="column" spacing={2}>
      <Grid item>
        <Paper style={styles}>
          <Typography variant="h6" gutterBottom>
            Default Paper
          </Typography>
        </Paper>
      </Grid>
      <Grid item>
        <Paper color="primary" style={styles}>
          <Typography variant="h6" color="inherit" gutterBottom>
            Primary Paper
          </Typography>
          Primary Paper
        </Paper>
      </Grid>
      <Grid item>
        <Paper color="accent" style={styles}>
          <Typography variant="h6" color="inherit" gutterBottom>
            Accent Paper
          </Typography>
          Accent Paper
        </Paper>
      </Grid>
      <Grid item>
        <Paper
          color="accent"
          style={{ ...styles, backgroundImage: `url(${firewatchBg})`, minHeight: 180 }}
        >
          <Typography variant="h6" color="inherit" gutterBottom>
            Paper with bg image
          </Typography>
        </Paper>
      </Grid>
      <Grid item>
        <Paper color="secondary" style={styles}>
          Secondary Paper
          <Typography variant="h6" color="inherit" gutterBottom>
            Secondary Paper
          </Typography>
        </Paper>
      </Grid>
      <Grid item>
        <Paper color="error" style={styles}>
          Error Paper
          <Typography variant="h6" color="inherit" gutterBottom>
            Error Paper
          </Typography>
        </Paper>
      </Grid>
    </Grid>
  ))
